import React from 'react';
import PropTypes from 'prop-types';
import UserSuggestions from './UserSuggestions';

import './Suggestions.css';

function UserSuggestionsContainer () {
  return (
    <div>
      <UserSuggestions />
    </div>
  );
}

export default UserSuggestionsContainer;
